import * as React from 'react';
import {HeaderSortDirection, ReactTableState} from "./ReactTable";
import {getReactButton, getReactTableLocal} from "../../index";
import {RefObject} from "react";

interface ReactMultiSelectSearchAsYouTypeData {
    id?: string,
    label?: string,
    tableLabel?: string,
    css?: string,
    divTableContainerCSS?: string,
    divSAYTTableContainerCSS?: string,
    style?: {},
    tableStyle?: {},
    saytTableStyle?: {},
    labelStyle?: {},
    labelCSS?: (selectedRecordIndex: number) => string,
    textStyle?: {},
    textCSS?: string,
    headers?: any[],
    headersCSS?: string,
    rowsCSS?: (row: any, rowIndex: number) => string,
    rowsStyle?: (row: any, rowIndex: number) => {},
    selectionHeaders?: any[],
    selectionHeadersCSS?: string,
    selectionRowsCSS?: (row: any, rowIndex: number) => string,
    selectionRowsStyle?: (row: any, rowIndex: number) => {},
    rows?: any[],
    tabIndex?: null,
    highlightSelectedRow?: number, // -1 to turn off
    hightlightSelectedRowCSS?: (row: any, rowIndex: number) => string,
    rowHasFocusCSS?: (row: any, rowIndex: number) => string,
    selectRecordWithRowClick?: boolean,
    selectRecordsWithRowDrag?: boolean,
    toolBarDisplayHeader?: boolean,
    toolBarDisplayFooter?: boolean,
    toolBarNumToDisplay?: number,
    selectColumns?: [],
    onSAYTClickEvent?: (row: any, storedData?: any) => {},
    hideSearchOnSelect?: boolean,
    showSearchButton?: boolean,
    searchButtonTabIndex?: null,
    disabled?: boolean,
    disableHeaderScrolling?: boolean,
    disableID?: string,
    refreshID?: string,
    toolBarRefreshID?: string,
    refreshSAYTTableID?: string,
    onRefresh?: () => {},
    onToolBarRefresh?: () => {},
    noRecordsSelectedText?: string,
    addCustomFilterOptions?: (storedData?: any, filteredRows?: any[]) => {},
    customFilter?: (row: any, storedData?: any, rowIndex?: number, searchValLowerCase?: string, origin?: number) => boolean,
    onFocusOut?: (storedData?: any) => null,
    isSelectedKey?: string,
    customFilterCSS?: string,
    onSortEvent?: () => void,
    selectHeaderClick?: (storedData?: any, selectAll?: boolean) => void,
    onSAYTTableDisplayEvent?: (saytTableObj: object, saytInputObj: object) => {},
    divSAYTWindowCSS?: string,
    onBeforeSAYTTableDisplayEvent?: () => null,
    hiddenSelectedKey?: string,
    hiddenSelectedKeyID?: string,
    hiddenSelectedKeyDelimiter?: string,
    storedData?: any,
    dataKey?: string,
    hiddenSelectedKeyName?: string,
    storedDataAsJSONArray?: boolean,
    newJSONData?: (row: any, rowIndex: number, jsonData: any) => {},
    onFocusOutEvent?: (clickedObject: any, bTab: boolean, bEscape: boolean, isCtrlKey: boolean, isAltKey: boolean) => boolean,
    overrideRowID? : (row: any, rowIndex: number, overallIndex: number) => string,
    overrideRowName? : (row: any, rowIndex: number, overallIndex: number) => string,
    selectCheckBoxID? : (row: any, rowIndex: number, overallIndex: number) => string,
    selectCheckBoxName? : (row: any, rowIndex: number, overallIndex: number) => string,
    tableOverrideRowID? : (row: any, rowIndex: number, overallIndex: number) => string,
    tableOverrideRowName? : (row: any, rowIndex: number, overallIndex: number) => string,
    tableSelectCheckBoxID? : (row: any, rowIndex: number, overallIndex: number) => string,
    tableSelectCheckBoxName? : (row: any, rowIndex: number, overallIndex: number) => string,
    overrideTableEntriesText?: string,
    hiddenTotalCountID?: string,
    onKeySelectionPressEvent?: (row: any, rowIndex: number, keyPressed: string, bShift: boolean, bCTRL: boolean, bAlt: boolean) => null,
    title?: (storedData?: any) => string,
    overrideScrollIntoView?: (element: any, rowIndex: number) => void,
    tableoverrideScrollIntoView?: (element: any, rowIndex: number) => void,
    overrideToolBarInfoText? : (totalRows: number, startPos: number, endPos: number, totalPages: number, page: number) => {},
    onKeyDown?: (rowObj: any, rowIndex: number, keyPressed: string, bShift: boolean, bCTRL: boolean, bALT: boolean) => boolean,
    onKeyUp?: (rowOBJ: any, rowIndex: number, keyPressed: string, bShift: boolean, bCTRL: boolean, bALT: boolean) => void,
    stopPropagationOnKeyPress?: (rowOBJ: any, rowIndex: number, keyPressed: string, bOnKeyUp: boolean, bShift: boolean, bCTRL: boolean, bALT: boolean) => boolean,
    autoComplete: string,
    isInitialLoad?: () => boolean,
    toolBarDisablePaging?: boolean,
    toolBarDisplayTotal?: () => number,
    onTableScroll?: (scrollTop: number, scrollHeight: number, clientHeight: number, selectIndex: number, numberOfRowsDisplayed: number, newZIndex: number) => void;
}

interface ReactMultiSelectSearchAsYouTypeState {
    showTable: boolean,
    enableKeyUpSelection: boolean,
    searchValue: string,
    highlightSelectedRow: number,
    toolBarPageNumber: number,
    toolBarPageNumberTyped: number,
    storedData: any, // Row used to store the selection
    rows: any[], // All Rows to display in the SAYT List
    selectedRows: any[], // Displayed Selected Table Rows
    headers: any[],
    filteredRows: any[], // Displayed SAYT Table Rows
    disabled: boolean
}

export class ReactMultiSelectSearchAsYouType extends React.Component<ReactMultiSelectSearchAsYouTypeData> {
    useHighlightSelectedRow: boolean;
    inputRef: RefObject<any>;
    hiddenSelectedKeyRef: RefObject<any>;
    useRowDataStorage: boolean;
    storedDataAsJSONArray: boolean;
    popupElement: HTMLDivElement;
    popupRef: RefObject<any>;
    popUpTableObj: object;

    // FIREFOX FIX: Returns true when a DOM event target corresponds to a
    // native <select> control (or one of its <option> children). The SAYT
    // popup's document-level mousedown handler uses this to avoid closing
    // the popup while the user is interacting with an embedded <select>,
    // which in Firefox would otherwise tear the backing element out of the
    // DOM and collapse the OS-level dropdown instantly.
    static isNativeSelectTarget(target: EventTarget | null): boolean {
        if (null == target) {
            return false;
        }
        const el = target as HTMLElement;
        const tag = (el && el.tagName) ? el.tagName.toUpperCase() : '';
        if (tag === 'SELECT' || tag === 'OPTION' || tag === 'OPTGROUP') {
            return true;
        }
        // Defensive: some browsers may nest controls; walk up a couple levels.
        if (el && typeof el.closest === 'function') {
            return null != el.closest('select');
        }
        return false;
    }

    constructor(props: ReactMultiSelectSearchAsYouTypeData) {
        super(props);

        // Binding is necessary to allow these functions access to the State data
        this.updateSAYT = this.updateSAYT.bind(this);
        this.onSelectCellClick = this.onSelectCellClick.bind(this);
        this.onClick = this.onClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.filterTable = this.filterTable.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.toolBarUpdate = this.toolBarUpdate.bind(this);
        this.highlightRow = this.highlightRow.bind(this);
        this.sortUpdate = this.sortUpdate.bind(this);
        this.toolBarPageLeft = this.toolBarPageLeft.bind(this);
        this.toolBarPageRight = this.toolBarPageRight.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.unselectAll = this.unselectAll.bind(this);
        this.onDisableClick = this.onDisableClick.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
        this.onRefreshSAYTOnly = this.onRefreshSAYTOnly.bind(this);
        this.onHiddenKeyChange = this.onHiddenKeyChange.bind(this);
        this.onSAYTTableDisplayEvent = this.onSAYTTableDisplayEvent.bind(this);
        this.onCloseWindowClick = this.onCloseWindowClick.bind(this);
        this.onShowWindowClick = this.onShowWindowClick.bind(this);
        this.updatePaging = this.updatePaging.bind(this);
        this.selectedTableSortUpdate = this.selectedTableSortUpdate.bind(this);

        this.inputRef = React.createRef();
        this.hiddenSelectedKeyRef = React.createRef();
        this.popupRef = React.createRef();
        this.popUpTableObj = null;
        this.popupElement = null;

        this.useHighlightSelectedRow = props.highlightSelectedRow >= 0;
        this.useRowDataStorage = (null != props.dataKey && null != props.hiddenSelectedKey && null != props.storedData);
        this.storedDataAsJSONArray = (this.useRowDataStorage && null != props.storedDataAsJSONArray) ? props.storedDataAsJSONArray : false;

        this.state = {
            rows: props.rows,
            showTable: false,
            enableKeyUpSelection: true,
            searchValue: '',
            highlightSelectedRow: props.highlightSelectedRow,
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1,
            filteredRows: this.filterTable('', props.rows, props.storedData, 1),
            selectedRows: props.rows.filter(row => {return this.filterUnselected(row, props.storedData);}),
            disabled: props.disabled,
            storedData: props.storedData,
        };
    }

    componentDidMount() {
        // Add Selection checkbox cells
        if(this.props.selectColumns.length > 0) {
            this.setState(() => {
                return {
                    rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
                    filteredRows: this.filterTable('', (this.state as ReactMultiSelectSearchAsYouTypeState).rows, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData, 2),
                    selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData);})
                }
            });
        }

        // ===== FIREFOX FIX =====
        // Patch the SAYT <input> element's own focus() method to be a no-op
        // whenever a native <select>/<option> inside our popup currently owns
        // focus. Firefox renders <select> dropdowns via the native OS and
        // closes them instantly if the backing <select> element loses focus,
        // even transiently. External jQuery code deep in the event chain can
        // call $(input).focus() while the user's SELECT is open, which
        // steals focus away and collapses the dropdown before the user can
        // pick an option (observed when embedding <select> controls in a
        // SAYT custom filter object). Chrome/Edge tolerate the transient
        // focus bounce; Firefox does not.
        //
        // We only block the focus call in that specific transient condition
        // (a SELECT/OPTION inside a SAYT popup currently has focus), so
        // normal SAYT focus handling is unaffected.
        try {
            const inp = this.inputRef.current as HTMLInputElement;
            if (inp && !(inp as any)._saytFocusPatched) {
                (inp as any)._saytFocusPatched = true;
                const originalFocus = inp.focus.bind(inp);
                const self = this;
                (inp as any).focus = function (opts?: any) {
                    const ae = document.activeElement as HTMLElement;
                    if (ae && (ae.tagName === 'SELECT' || ae.tagName === 'OPTION' || ae.tagName === 'OPTGROUP')) {
                        const popup = self.popupElement;
                        const insidePopup = !!(popup && popup.contains(ae));
                        const insideAnySAYTPopup = !insidePopup && typeof ae.closest === 'function' && !!ae.closest('[id$="_popUpWindow"]');
                        if (insidePopup || insideAnySAYTPopup) {
                            // Suppress: focusing the input now would close
                            // the native <select> dropdown in Firefox.
                            return;
                        }
                    }
                    return originalFocus(opts);
                };
            }
        } catch (e) {
            // Ignore -- fallback to default behavior
        }
    }

    // Update the state externally
    componentDidUpdate(prevProps: ReactMultiSelectSearchAsYouTypeData) {
        // Check if relevant props have changed
        if (prevProps.disabled !== this.props.disabled ||
            prevProps.rows !== this.props.rows ||
            prevProps.storedData !== this.props.storedData) {

            this.setState({
                disabled: this.props.disabled,
                rows: this.props.rows,
                storedData: this.props.storedData,
                selectedRows: this.props.rows.filter(row => {return this.filterUnselected(row, this.props.storedData);}),
            }, () => {this.updateHiddenSelectedKey();});
        }
    }

    indexOfStoredDataString(storedDataString: string, key: string) {
        const selectedKeyList = storedDataString.split(this.props.hiddenSelectedKeyDelimiter);
        return selectedKeyList.indexOf(key);
    }

    indexOfStoredDataJSON(data: any, key: string) {
        for (let i = 0; i < data.length; i++) {
            if(data[i][this.props.dataKey] === key) {
                return i;
            }
        }

        return -1;
    }

    // Removes rows that are not selected from the Selection Table
    filterUnselected(row: any, storedData: any) {
        if(this.storedDataAsJSONArray) {
            return this.indexOfStoredDataJSON(storedData, row[this.props.hiddenSelectedKey]) > -1;
        } else if(this.useRowDataStorage) {
            return (null != storedData[this.props.dataKey] && null != row[this.props.hiddenSelectedKey] && this.indexOfStoredDataString((null != storedData[this.props.dataKey]) ? storedData[this.props.dataKey] : "", row[this.props.hiddenSelectedKey]) > -1);
        } else {
            return (null != row[this.props.isSelectedKey] && row[this.props.isSelectedKey] == true);
        }
    }

    getStoredJSONData(rowIndex: number) {
        let jsonData: any = {};
        jsonData[this.props.dataKey] = (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.hiddenSelectedKey];

        if(null != this.props.newJSONData) {
            jsonData = this.props.newJSONData((this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex], rowIndex, jsonData);
        }
        return jsonData;
    }

    updateSAYT(rowIndex: number, setSelected: boolean) {
        if(rowIndex >= 0) {

            if(this.storedDataAsJSONArray) {
                if(setSelected) {
                    const storageIndex = this.indexOfStoredDataJSON((this.state as ReactMultiSelectSearchAsYouTypeState).storedData, (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.hiddenSelectedKey])
                    if(storageIndex <= -1) {
                        (this.state as ReactMultiSelectSearchAsYouTypeState).storedData.push(this.getStoredJSONData(rowIndex));
                    }
                } else {
                    const storageIndex = this.indexOfStoredDataJSON((this.state as ReactMultiSelectSearchAsYouTypeState).storedData, (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.hiddenSelectedKey]);
                    if(storageIndex > -1) {
                        (this.state as ReactMultiSelectSearchAsYouTypeState).storedData.splice(storageIndex, 1);
                    }
                }
            } else if(this.useRowDataStorage) {
                const keyVal = (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.hiddenSelectedKey];
                const selectedKeyList = (null != (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey] && '' != (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey]) ? (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey].split(this.props.hiddenSelectedKeyDelimiter) : [];
                const storageIndex = selectedKeyList.indexOf(keyVal);
                if(storageIndex > -1) {
                    if(!setSelected) {
                        selectedKeyList.splice(storageIndex, 1);
                    }
                } else {
                    if(setSelected) {
                        selectedKeyList.push(keyVal);
                    }
                }
                (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey] = selectedKeyList.join(this.props.hiddenSelectedKeyDelimiter);
            } else {
                (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.isSelectedKey] = setSelected;
            }

            this.setState({
                    searchValue: '',
                    storedData: (this.state as ReactMultiSelectSearchAsYouTypeState).storedData,
                    rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
                    selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData);}),
                    highlightSelectedRow: (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow,
                    toolBarPageNumber: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber,
                    toolBarPageNumberTyped: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumberTyped
            }, () => {
                if (null != this.props.onSAYTClickEvent) {
                    this.props.onSAYTClickEvent((this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex], (this.state as ReactMultiSelectSearchAsYouTypeState).storedData);
                }
            });
        }
    }

    // SAYT was clicked, display the search table
    onClick() {
        this.inputRef.current.focus();

        if(!(this.state as ReactMultiSelectSearchAsYouTypeState).showTable) {
            this.onFocusIn();
        }

        if(!(this.state as ReactMultiSelectSearchAsYouTypeState).showTable && null != this.props.onBeforeSAYTTableDisplayEvent) {
            this.props.onBeforeSAYTTableDisplayEvent();
        }

        this.setState({
            showTable: true,
            enableKeyUpSelection: true,
            searchValue: '',
            filteredRows: this.filterTable('', (this.state as ReactMultiSelectSearchAsYouTypeState).rows, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData, 4),
            selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData);}),
            highlightSelectedRow: ((this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow == -1) ? -1 : 0,
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1
        });

        // Add a mousedown event to trigger once we click away from the SAYT
        const inputElement = $(this.inputRef.current);

        const clickEvent = 'mousedown.' + this.props.id;
        $(document.body).on(clickEvent, (event2) => {
            // FIREFOX FIX: Native <select> / <option> interactions must never
            // be treated as an "outside click". In Firefox the OS-level
            // dropdown can deliver mousedown targets that are not strictly
            // descendants of our popup container, which would otherwise cause
            // us to close the SAYT popup and destroy the <select> mid-click.
            if (ReactMultiSelectSearchAsYouType.isNativeSelectTarget(event2.target)) {
                return;
            }

            const popupTableObject = (null != this.popUpTableObj) ? $(this.popUpTableObj) : $(this.popupRef.current);

            if((inputElement.closest('div').find($(event2.target)).length < 1) &&
                (popupTableObject.find($(event2.target)).length < 1))
            {
                let bFocusOut = true;
                if(null != this.props.onFocusOutEvent) {
                    bFocusOut = this.props.onFocusOutEvent($(event2.currentTarget), false, false, event2.ctrlKey, event2.altKey);
                }
                if(bFocusOut) {
                    this.onFocusOut();
                }
            }
        });
    }

    // User changed something in the SAYT Text field
    handleChange(event: any) {
        this.setState({
            showTable: true,
            enableKeyUpSelection: true,
            searchValue: event.target.value,
            rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
            filteredRows: this.filterTable(event.target.value, (this.state as ReactMultiSelectSearchAsYouTypeState).rows, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData, 3),
            selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData);}),
            headers: (this.state as ReactMultiSelectSearchAsYouTypeState).headers,
            highlightSelectedRow: ((this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow == -1) ? -1 : 0,
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1
        });
    }

    // Filter using the Search String
    searchCell(header: any, row: any, searchVal: string, searchValLowerCase: string) {
        let searchKey = (null != header.displayKey) ? header.displayKey : '';
        if(null != header.hiddenSearchKey) {
            searchKey = header.hiddenSearchKey;
        }

        // Some columns can be excluded from the search (by default all columns are searched on)
        if(null != header.disableSearch) {
            return false;
        } else if(null != header.customSearch) {
            return header.customSearch(row, searchValLowerCase, searchVal);
        } else if(searchKey.length > 0 && row[searchKey]) {
            if(typeof row[searchKey] == "string") {
                if(null != header.searchOption) {
                    if(header.searchOption.toLowerCase().localeCompare("startswith") == 0) {
                        return row[searchKey].toLowerCase().startsWith(searchValLowerCase);
                    } else if(header.searchOption.localeCompare("endswith") == 0 ) {
                        return row[searchKey].toLowerCase().endsWith(searchValLowerCase);
                    } else {
                        return row[searchKey].toLowerCase().includes(searchValLowerCase);
                    }
                } else {
                    return row[searchKey].toLowerCase().includes(searchValLowerCase);
                }
            } else if(typeof row[searchKey] == "number") {
                if(null != header.searchOption) {
                    if(header.searchOption.toLowerCase().localeCompare("startswith") == 0) {
                        return row[searchKey].toString().startsWith(searchValLowerCase);
                    } else if(header.searchOption.toLowerCase().localeCompare("endswith") == 0) {
                        return row[searchKey].toString().endsWith(searchValLowerCase);
                    } else {
                        return row[searchKey].toString().includes(searchValLowerCase);
                    }
                } else {
                    return row[searchKey].toString().includes(searchValLowerCase);
                }
            } else if(null != row[searchKey].props) {
                if(null != row[searchKey].props.value) {
                    if(null != header.searchOption) {
                        if(header.searchOption.toLowerCase().localeCompare("startswith") == 0) {
                            return row[searchKey].props.value.toLowerCase().startsWith(searchValLowerCase);
                        } else if(header.searchOption.toLowerCase().localeCompare("endswith") == 0) {
                            return row[searchKey].props.value.toLowerCase().endsWith(searchValLowerCase);
                        } else {
                            return row[searchKey].props.value.toLowerCase().includes(searchValLowerCase);
                        }
                    } else {
                        return row[searchKey].props.value.toLowerCase().includes(searchValLowerCase);
                    }
                }
            }
        }
        return false;
    }

    searchRow(row: any, searchVal: string, searchValLowerCase: string, storedData: any, rowIndex: number, origin: number) {
        let skipCustomFilter = true;

        // Filter using the customFilter in addition to the SAYT
        if(null != this.props.customFilter) {
            skipCustomFilter = this.props.customFilter(row, storedData, rowIndex, searchValLowerCase, origin);
        }

        // Filter using the SAYT
        return skipCustomFilter && ((searchValLowerCase.length > 0) ? this.props.headers.map((header) => this.searchCell(header, row, searchVal, searchValLowerCase)).includes(true) : true);
    }

    // Filter the rows off of the SAYT and off of the customFilter if it exists
    filterTable(searchVal: string, rows: any[], storedData: any, origin: number) {
        const searchValLowerCase = (searchVal.length > 0) ? searchVal.toLowerCase() : '';
        return rows.filter((row, rowIndex) => this.searchRow(row, searchVal, searchValLowerCase.trim(), storedData, rowIndex, origin));
    }

    onFocusIn() {
        // Idempotency: the <input> has onFocus={this.onFocusIn}, so this
        // runs every time the input gains focus. If the popup is already
        // set up, do NOT re-run (which would re-add duplicate body-level
        // mousedown listeners and attempt to re-parent the popup). This is
        // especially important in Firefox, where focus can briefly move to
        // a <select> inside the popup and bounce back to the input.
        if (null != this.popupElement) {
            return;
        }
        const inputElement = $(this.inputRef.current);

        this.popupElement = document.createElement("div");
        this.popupElement.id = this.props.id + "_popUpWindow";
        this.popupElement.className = "positionAbsolute";
        this.popupElement.appendChild(this.popupRef.current);
        document.body.appendChild(this.popupElement);

        // Add a mousedown event to trigger once we click away from the SAYT
        const clickEvent = 'mousedown.' + this.props.id;
        $(document.body).on(clickEvent, (event2) => {
            // FIREFOX FIX: Ignore mousedown originating from a native
            // <select> or <option>. See companion comment in the showTable
            // handler -- this prevents Firefox's native dropdown from being
            // closed mid-click when a <select> is embedded in a custom
            // filter object.
            if (ReactMultiSelectSearchAsYouType.isNativeSelectTarget(event2.target)) {
                return;
            }

            const popUpTableObject = (null != this.popUpTableObj) ? $(this.popUpTableObj) : $(this.popupRef.current);

            if((inputElement.closest('div').find($(event2.target)).length < 1) &&
                (popUpTableObject.find($(event2.target)).length < 1))
            {
                let bFocusOut = true;
                if(null != this.props.onFocusOutEvent) {
                    bFocusOut = this.props.onFocusOutEvent($(event2.target), false, false, event2.ctrlKey, event2.altKey);
                }
                if(bFocusOut) {
                    this.onFocusOut();
                }
            }
        });

        const hotKeyEvent = 'keydown.' + this.props.id;
        $(document.body).on(hotKeyEvent, (hotKeyEvent) => {
            if(hotKeyEvent.altKey && hotKeyEvent.key !== "Alt") {
                const popUpTableObject = (null != this.popUpTableObj) ? $(this.popUpTableObj) : $(this.popupRef.current);

                if((inputElement.closest('div').find($(hotKeyEvent.currentTarget)).length < 1) &&
                    (popUpTableObject.closest('div').find($(hotKeyEvent.currentTarget)).length < 1))
                {
                    let bFocusOut = true;
                    if(null != this.props.onFocusOutEvent) {
                        bFocusOut = this.props.onFocusOutEvent($(hotKeyEvent.currentTarget), false, false, hotKeyEvent.ctrlKey, hotKeyEvent.altKey);
                    }
                    if(bFocusOut) {
                        this.onFocusOut();
                    }
                }
            }
        });
    }

    onFocusOut() {
        // Remove mousedown event listener that was added when we displayed the SAYT Search Table
        const clickEvent = 'mousedown.' + this.props.id;
        $(document.body).off(clickEvent);

        // Remove keydown event listener that was added when we displayed the SAYT Search Table
        const hotKeyEvent = 'keydown.' + this.props.id;
        $(document.body).off(hotKeyEvent);

        $(this.popupElement).remove();
        this.popupElement = null;

        this.setState({
            searchValue: '',
            rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
            showTable: false,
            enableKeyUpSelection: true,
        });

        // Call focus out function if one exists
        if(this.props.onFocusOut) {
            this.props.onFocusOut((this.state as ReactMultiSelectSearchAsYouTypeState).storedData);
        }
    }

    // Get the next row to highlight for the highlightSelectedRow
    getNextRow(rowIndex: number, keyUp: boolean, totalRows: number) {
        let nextRow = rowIndex;
        if(keyUp) {
            if(nextRow > 0) {
                nextRow--;
            }
        } else {
            if(nextRow < (totalRows - 1)) {
                nextRow++;
            }
        }
        return nextRow;
    }

    toolBarPageLeft() {
        this.setState((prev: ReactMultiSelectSearchAsYouTypeState) => ({
            toolBarPageNumber: ((prev.toolBarPageNumber > 1) ? prev.toolBarPageNumber - 1 : 1),
            toolBarPageNumberTyped: ((prev.toolBarPageNumber > 1) ? prev.toolBarPageNumber - 1 : 1),
            highlightSelectedRow: ((this.useHighlightSelectedRow) ? ((prev.toolBarPageNumber > 1) ? 0 : (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow): -1)
        }));
    }

    toolBarPageRight() {
        const totalPages = Math.ceil((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length/this.props.toolBarNumToDisplay);
        this.setState(() => ({
            toolBarPageNumber: (((this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber < totalPages) ? (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber + 1 : (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber),
            toolBarPageNumberTyped: (((this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber < totalPages) ? (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber + 1 : (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber),
            highlightSelectedRow: ((this.useHighlightSelectedRow) ? (((this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber < totalPages) ? 0 : (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow): -1)
        }));
    }

    toolBarUpdate(props: ReactTableState) {
        this.setState(() => ({
            toolBarPageNumber: props.toolBarPageNumber,
            toolBarPageNumberTyped: props.toolBarPageNumberTyped,
            highlightSelectedRow: ((this.useHighlightSelectedRow) ? ((props.highlightSelectedRow >= 0) ? props.highlightSelectedRow : 0) : -1)
        }));
    }

    getIndexFromHighlight() {
        return (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow + (((this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
    }

    getHighlightIndex(indexToHighlight: number) {
        return indexToHighlight % this.props.toolBarNumToDisplay;
    }

    highlightRow(event: any) {
        const rowIndex = +$(event.currentTarget).val();// Adjust the page number if needed
        if(rowIndex > -1 && rowIndex < (this.state as ReactMultiSelectSearchAsYouTypeState).rows.length) {
            const selectedIndex = this.getHighlightIndex(rowIndex);
            const totalPages = Math.ceil((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length/this.props.toolBarNumToDisplay);

            let goToPage = Math.ceil((rowIndex + 1)/this.props.toolBarNumToDisplay);
            if(goToPage < 1) {
                goToPage = 1;
            } else if(goToPage > totalPages) {
                goToPage = totalPages;
            }

            this.setState((prev: ReactMultiSelectSearchAsYouTypeState) => ({
                toolBarPageNumber: goToPage,
                toolBarPageNumberTyped: goToPage,
                highlightSelectedRow: selectedIndex,
            }));
        }
    }

    sortUpdate(props: ReactTableState, onLoad: boolean) {
        this.setState(() => ({
            filteredRows: this.filterTable((this.state as ReactMultiSelectSearchAsYouTypeState).searchValue, props.rows, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData, 6),
            selectedRows: props.rows.filter(row => {return this.filterUnselected(row, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData);}),
        }), () => {this.updateHiddenSelectedKey();});
        this.toolBarUpdate(props);
    }

    selectedTableSortUpdate(props: ReactTableState, onLoad: boolean) {
        // Use the already-sorted filteredRows from ReactTable's internal state.
        // filteredRows contains the sorted selected rows that ReactTable has already processed.
        this.setState(() => ({
            selectedRows: props.filteredRows,
        }), () => {this.updateHiddenSelectedKey();});
    }

    onShowWindowClick(event: any) {
        if((this.state as ReactMultiSelectSearchAsYouTypeState).showTable) {
            this.onFocusOut();
        } else {
            this.onClick();
        }
    }

    updatePaging(pageNumber: number) {
        this.setState((prev: ReactMultiSelectSearchAsYouTypeState) => ({
            toolBarPageNumber: pageNumber,
            toolBarPageNumberTyped: pageNumber,
        }));
    }

    onCloseWindowClick(event: any) {
        this.onFocusOut();
    }

    onKeyUp(event: any) {
        if(null != this.props.onKeyUp) {
            const selectIndex = (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow;
            const selectRow = (selectIndex > -1 && selectIndex < (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length) ?  (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[(this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow] : null;
            this.props.onKeyUp(selectRow, selectIndex, event.key, event.shiftKey, event.ctrlKey, event.altKey);
        }

        const keyEnter = event.key == "Enter";
        if((this.state as ReactMultiSelectSearchAsYouTypeState).enableKeyUpSelection) {
            if(keyEnter) {
                // Select the highlight selected row on enter
                if(this.useHighlightSelectedRow) {
                    const selectIndex = (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow + (((this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
                    if(selectIndex >= 0 && selectIndex < (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length) {
                        const filteredRow = (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[selectIndex];
                        this.onSelectCellClick(filteredRow, event.shiftKey, event.ctrlKey, true);
                    }
                }
            }
        }

        this.setState({
            enableKeyUpSelection: true,
        });


        if(null != this.props.stopPropagationOnKeyPress) {
            const selectIndex = (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow;
            const selectRow = (selectIndex > -1 && selectIndex < (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length) ?  (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[(this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow] : null;
            if(this.props.stopPropagationOnKeyPress(selectRow, selectIndex, event.key, true, event.shiftKey, event.ctrlKey, event.altKey)) {
                event.stopPropagation();
            }
        }
    }

    // User typed something in the SAYT Text field
    onKeyPress(event: any, ignoreOverride?: boolean) {
        const keyUp = event.key == "ArrowUp";
        const keyDown = event.key == "ArrowDown";
        const keyLeft = event.key == "ArrowLeft";
        const keyRight = event.key == "ArrowRight";
        const keyTab = event.key == "Tab";
        const keyEsc = event.key == "Escape";
        const keyEnter = event.key == "Enter";
        const keyDelete = event.key == "Delete";
        const keyBackspace = event.key == "Backspace";
        const keyIsInvisible = ((event.key == "Backspace") || (event.key == "Delete") || (event.key == "Shift") || (event.key == "CapsLock") || (event.key == "Control") || (event.key == "Alt"));
        const resetSearchList = ((this.state as ReactMultiSelectSearchAsYouTypeState).searchValue.length == 0 && keyIsInvisible && (this.state as ReactMultiSelectSearchAsYouTypeState).showTable);
        let keyPressed = false;

        // If the table is not displayed, determine if the key pressed should display it
        // Special keys like "Shift" should not display the table
        if(resetSearchList || ((event.key.length == 1 || (keyUp || keyDown || keyLeft || keyRight || keyEnter || keyDelete || keyBackspace)) && !(this.state as ReactMultiSelectSearchAsYouTypeState).showTable)) {
            if(!(this.state as ReactMultiSelectSearchAsYouTypeState).showTable && null != this.props.onBeforeSAYTTableDisplayEvent) {
                this.props.onBeforeSAYTTableDisplayEvent();
            }

            this.onFocusIn();

            this.setState({
                showTable: true,
                enableKeyUpSelection: false, // Prevent enter key from selecting anything while we are still trying to display the pop-up
                searchValue: '',
                filteredRows: this.filterTable('', (this.state as ReactMultiSelectSearchAsYouTypeState).rows, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData, 5),
                selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData);}),
                highlightSelectedRow: ((this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow == -1) ? -1 : 0,
                toolBarPageNumber: 1,
                toolBarPageNumberTyped: 1
            });
        } else if (null == ignoreOverride && !ignoreOverride && null != this.props.onKeySelectionPressEvent && (keyUp || keyDown || keyLeft || keyRight || keyEnter)) {
            const selectIndex = (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow;
            const selectRow = (selectIndex > -1 && selectIndex < (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length) ?  (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[(this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow] : null;
            this.props.onKeySelectionPressEvent(selectRow, selectIndex, event.key, event.shiftKey, event.ctrlKey, event.altKey);
            keyPressed = true;
        } else if (this.useHighlightSelectedRow && (keyUp || keyDown)) {
            // Adjust the highlight row selected
            let updateHighlightPosition = true;
            let newSelectedRow = this.getNextRow((this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow, keyUp, (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length);

            // Adjust the page number if needed
            let pageNumber = (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber;
            if(keyUp && pageNumber > 1 && (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow == 0) {
                newSelectedRow = this.props.toolBarNumToDisplay - 1;
                pageNumber--;
            } else if(keyDown) {
                if((newSelectedRow + ((pageNumber - 1) * this.props.toolBarNumToDisplay)) <= ((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length - 1)) {
                    if(newSelectedRow >= this.props.toolBarNumToDisplay) {
                        const totalPages = Math.ceil((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length/this.props.toolBarNumToDisplay);
                        if (pageNumber < totalPages) {
                            newSelectedRow = 0;
                            pageNumber++;
                        } else {
                            updateHighlightPosition = false;
                        }
                    }
                } else {
                    updateHighlightPosition = false;
                }
            }

            keyPressed = true;

            // If the highlight position should be adjusted update the state
            if(updateHighlightPosition) {
                this.setState({
                    highlightSelectedRow: newSelectedRow,
                    toolBarPageNumber: pageNumber,
                    toolBarPageNumberTyped: pageNumber
                });
            }
        } else if (keyLeft || keyRight) {
            // Update the page number using the left and right keyboard arrow keys
            if (keyLeft) {
                this.toolBarPageLeft();
                keyPressed = true;
            } else if (keyRight) {
                this.toolBarPageRight();
                keyPressed = true;
            }
        } else if(keyTab || keyEsc) {
            let bFocusOut = true;
            if(null != this.props.onFocusOutEvent) {
                bFocusOut = this.props.onFocusOutEvent($(event.currentTarget), keyTab, keyEsc, event.ctrlKey, event.altKey);
            }
            if(bFocusOut) {
                this.onFocusOut();
            }
        }

        if (null != this.props.onKeyDown) {
            const selectIndex = (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow;
            const selectRow = (selectIndex > -1 && selectIndex < (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length) ?  (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[(this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow] : null;
            this.props.onKeyDown(selectRow, selectIndex, event.key, event.shiftKey, event.ctrlKey, event.altKey);
        }

        if (keyPressed || keyEnter) {
            event.preventDefault();
        }

        if (null != this.props.stopPropagationOnKeyPress) {
            const selectIndex = (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow;
            const selectRow = (selectIndex > -1 && selectIndex < (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length) ?  (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[(this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow] : null;
            if(this.props.stopPropagationOnKeyPress(selectRow, selectIndex, event.key, false, event.shiftKey, event.ctrlKey, event.altKey)) {
                event.stopPropagation();
            }
        }
    }

    onSelectCellClick(row: any, shiftKey: boolean, ctrlKey: boolean, applySelection: boolean) {
        const rowIndex = this.indexOfRow(row);

        // If the table is Disabled don't allow row selecting
        if(!(this.state as ReactMultiSelectSearchAsYouTypeState).disabled) {
            if (rowIndex >= 0) {
                let isSelected = true;

                if(this.storedDataAsJSONArray) {
                    const storageIndex = this.indexOfStoredDataJSON((this.state as ReactMultiSelectSearchAsYouTypeState).storedData, (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.hiddenSelectedKey]);
                    isSelected = (applySelection) ? !(storageIndex > -1) : (storageIndex > -1);
                } else if(this.useRowDataStorage) {
                    const keyVal = (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.hiddenSelectedKey];
                    const selectedKeyList = (null != (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey]) ? (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey].split(this.props.hiddenSelectedKeyDelimiter) : [];
                    const storageIndex = selectedKeyList.indexOf(keyVal);
                    isSelected = (applySelection) ? !(storageIndex > -1) : (storageIndex > -1);
                } else {
                    if((null != (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.isSelectedKey]) && ('undefined' != (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.isSelectedKey])) {
                        isSelected = (applySelection) ? !(this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.isSelectedKey] : (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.isSelectedKey];
                    }
                }

                this.updateSAYT(rowIndex, isSelected);
            }
            this.updateHiddenSelectedKey();
        }
    }

    // Get the index of the first selected row
    indexOfSelected() {
        if(this.storedDataAsJSONArray) {
            if((this.state as ReactMultiSelectSearchAsYouTypeState).storedData.length > 0) {
                for(let i = 0; i < (this.state as ReactMultiSelectSearchAsYouTypeData).rows.length; i++) {
                    const storageIndex = this.indexOfStoredDataJSON((this.state as ReactMultiSelectSearchAsYouTypeState).storedData, (this.state as ReactMultiSelectSearchAsYouTypeState).rows[i][this.props.hiddenSelectedKey]);
                    if(storageIndex > -1) {
                        return i;
                    }
                }
            }
        } else if(this.useRowDataStorage) {
            if(null != (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey] && '' != (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey]) {
                const selectedKeyList = (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey].split(this.props.hiddenSelectedKeyDelimiter);
                for(let i = 0; i < (this.state as ReactMultiSelectSearchAsYouTypeData).rows.length; i++) {
                    if(selectedKeyList.indexOf((this.state as ReactMultiSelectSearchAsYouTypeData).rows[i][this.props.hiddenSelectedKey]) > -1) {
                        return i;
                    }
                }
            }
        } else {
            for(let i = 0; i < (this.state as ReactMultiSelectSearchAsYouTypeData).rows.length; i++) {
                if((this.state as ReactMultiSelectSearchAsYouTypeData).rows[i][this.props.isSelectedKey]) {
                    return i;
                }
            }
        }

        return -1;
    }

    // Disable/enable the MultiSelect SAYT
    onDisableClick(event: any) {
        const isChecked = $(event.currentTarget).is(":checked");
        this.setState({
            disabled: isChecked
        });
    }

    // Refresh both SAYT and Selection Tables
    onRefresh() {
        if(null != this.props.onRefresh) {
            this.props.onRefresh();
        }

        if(null != this.props.isInitialLoad && this.props.isInitialLoad()) {
            this.setState((prev: ReactMultiSelectSearchAsYouTypeState) => ({
                filteredRows: this.filterTable(prev.searchValue, (this.state as ReactMultiSelectSearchAsYouTypeState).rows, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData, 7),
                selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData);}),
            }), () => {this.updateHiddenSelectedKey();});
        } else {
            this.setState((prev: ReactMultiSelectSearchAsYouTypeState) => ({
                filteredRows: this.filterTable(prev.searchValue, (this.state as ReactMultiSelectSearchAsYouTypeState).rows, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData, 7),
                selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData);}),
                toolBarPageNumber: 1,
                toolBarPageNumberTyped: 1,
            }), () => {this.updateHiddenSelectedKey();});
        }
    }

    // Refresh the SAYT table and not the Selection Table
    onRefreshSAYTOnly() {
        if(null != this.props.onRefresh) {
            this.props.onRefresh();
        }

        this.setState((prev: ReactMultiSelectSearchAsYouTypeState) => ({
            filteredRows: this.filterTable(prev.searchValue, (this.state as ReactMultiSelectSearchAsYouTypeState).rows, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData, 7),
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1,
        }));
    }

    onSAYTTableDisplayEvent(saytTableObj: object) {
        if(null != this.props.onSAYTTableDisplayEvent) {
            if($(this.popupElement) && this.inputRef.current) {
                $(this.popupElement).height($(saytTableObj).height());
                $(this.popupElement).width($(saytTableObj).width());
                this.props.onSAYTTableDisplayEvent($(this.popupElement), $(this.inputRef.current));
            }
        }
        this.popUpTableObj = saytTableObj;
    }

    indexOfHiddenSelectedKey(key: string) {
        if(null != this.props.hiddenSelectedKey) {
            for(let i = 0; i < (this.state as ReactMultiSelectSearchAsYouTypeState).rows.length; i++) {
                if(key == (this.state as ReactMultiSelectSearchAsYouTypeState).rows[i][this.props.hiddenSelectedKey]) {
                    return i;
                }
            }
        }

        return -1;
    }

    getSelectedKeys() {
        let selectedKeyList:string[] = [];

        if(this.storedDataAsJSONArray) {
            for(let i = 0; i < (this.state as ReactMultiSelectSearchAsYouTypeState).storedData.length; i++) {
                selectedKeyList.push((this.state as ReactMultiSelectSearchAsYouTypeState).storedData[i][this.props.dataKey]);
            }
        } else if(this.useRowDataStorage) {
            if(null != (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey] && '' != (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey]) {
                selectedKeyList = (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey].split(this.props.hiddenSelectedKeyDelimiter);
            }
        } else {
            for(let i = 0; i < (this.state as ReactMultiSelectSearchAsYouTypeState).rows.length; i++) {
                if((this.state as ReactMultiSelectSearchAsYouTypeState).rows[i][this.props.isSelectedKey]) {
                    selectedKeyList.push((this.state as ReactMultiSelectSearchAsYouTypeState).rows[i][this.props.hiddenSelectedKey]);
                }
            }
        }

        return selectedKeyList;
    }

    updateHiddenSelectedKey() {
        if(null != this.props.hiddenSelectedKey) {
            const selectedKeyList = this.getSelectedKeys();
            if(selectedKeyList.length > 0) {
                $(this.hiddenSelectedKeyRef.current).val(selectedKeyList.join(this.props.hiddenSelectedKeyDelimiter));
            } else {
                $(this.hiddenSelectedKeyRef.current).val("");
            }
        }
    }

    onHiddenKeyChange(event: any) {
        // If the table is Disabled don't allow row selecting
        if(!(this.state as ReactMultiSelectSearchAsYouTypeState).disabled) {
            const selectedString = $(event.currentTarget).val() as String;

            this.unselectAll();

            if(selectedString.length > 0) {
                const selectedKeyList = (selectedString).split(this.props.hiddenSelectedKeyDelimiter);
                for (let i = 0; i < selectedKeyList.length; i++) {
                    const rowIndex = this.indexOfHiddenSelectedKey(selectedKeyList[i]);
                    if(rowIndex > -1) {
                        if (rowIndex >= 0) {
                            this.updateSAYT(rowIndex, true);
                        }
                    }
                }
            }
            this.updateHiddenSelectedKey();
        }
    }

    // Get the index of the row in the rows array
    indexOfRow(row: any) {
        for(let i = 0; i < (this.state as ReactMultiSelectSearchAsYouTypeState).rows.length; i++) {
            if(row == (this.state as ReactMultiSelectSearchAsYouTypeState).rows[i] as any) {
                return i;
            }
        }

        return -1;
    }

    // Unselect all records in the rows array
    unselectAll() {
        // Do nothing if the table is Disabled
        if(!(this.state as ReactMultiSelectSearchAsYouTypeState).disabled) {
            // Unselect all of the rows (even rows filtered and rows off page)
            if(this.storedDataAsJSONArray) {
                (this.state as ReactMultiSelectSearchAsYouTypeState).storedData.splice(0, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData.length);
            } else if(this.useRowDataStorage) {
                (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey] = "";
            } else {
                for(let i = 0; i < (this.state as ReactMultiSelectSearchAsYouTypeState).rows.length; i++) {
                    (this.state as ReactMultiSelectSearchAsYouTypeState).rows[i][this.props.isSelectedKey] = false;
                }
            }

            // Update the current state
            this.setState({
                searchValue: '',
                storedData: (this.state as ReactMultiSelectSearchAsYouTypeState).storedData,
                rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
                filteredRows: this.filterTable('', (this.state as ReactMultiSelectSearchAsYouTypeState).rows, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData, 8),
                selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData);}),
                highlightSelectedRow: (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow,
                toolBarPageNumber: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber,
                toolBarPageNumberTyped: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumberTyped
            }, () => {this.updateHiddenSelectedKey();});

            if(null != this.props.selectHeaderClick) {
                this.props.selectHeaderClick((this.state as ReactMultiSelectSearchAsYouTypeState).storedData, false);
            }
        }
    }

    // Select/Unselect all displayed rows
    selectAll() {
        // Do nothing if the table is Disabled
        if(!(this.state as ReactMultiSelectSearchAsYouTypeState).disabled) {
            const startingIndex = (((this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
            let endingIndex = startingIndex + this.props.toolBarNumToDisplay;
            if (endingIndex > (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length) {
                endingIndex = (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length;
            }

            if(this.storedDataAsJSONArray) {
                if(((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length > 0)) {
                    const startKey = ((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[startingIndex][this.props.hiddenSelectedKey]);


                    let markAsSelected = !(this.indexOfStoredDataJSON((this.state as ReactMultiSelectSearchAsYouTypeState).storedData, startKey) > -1);

                    if(markAsSelected) {
                        for (let i = startingIndex; i < endingIndex; i++) {
                            const rowIndex = this.indexOfRow((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[i]);
                            if (rowIndex > -1) {
                                const storageIndex = this.indexOfStoredDataJSON((this.state as ReactMultiSelectSearchAsYouTypeState).storedData, (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.hiddenSelectedKey])
                                if(storageIndex <= -1) {
                                    (this.state as ReactMultiSelectSearchAsYouTypeState).storedData.push(this.getStoredJSONData(rowIndex));
                                }
                            }
                        }
                    } else {
                        for (let i = startingIndex; i < endingIndex; i++) {
                            const rowIndex = this.indexOfRow((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[i]);
                            if (rowIndex > -1) {
                                const storageIndex = this.indexOfStoredDataJSON((this.state as ReactMultiSelectSearchAsYouTypeState).storedData, (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.hiddenSelectedKey])
                                if(storageIndex > -1) {
                                    (this.state as ReactMultiSelectSearchAsYouTypeState).storedData.splice(storageIndex, 1);
                                }
                            }
                        }
                    }
                } else {
                    (this.state as ReactMultiSelectSearchAsYouTypeState).storedData.splice(0, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData.length);
                }
            } else if(this.useRowDataStorage) {
                if(((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length > 0)) {
                    const startKey = ((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[startingIndex][this.props.hiddenSelectedKey]);
                    const selectedKeyList = (null != (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey] && '' != (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey]) ? (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey].split(this.props.hiddenSelectedKeyDelimiter) : [];
                    let markAsSelected = !(selectedKeyList.indexOf(startKey) > -1);

                    if(markAsSelected) {
                        for (let i = startingIndex; i < endingIndex; i++) {
                            const rowIndex = this.indexOfRow((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[i]);
                            if (rowIndex > -1) {
                                const storageIndex = selectedKeyList.indexOf((this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.hiddenSelectedKey]);
                                if(storageIndex <= -1) {
                                    selectedKeyList.push((this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.hiddenSelectedKey]);
                                }
                            }
                        }
                        (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey] = selectedKeyList.join(this.props.hiddenSelectedKeyDelimiter);
                    } else {
                        for (let i = startingIndex; i < endingIndex; i++) {
                            const rowIndex = this.indexOfRow((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[i]);
                            if (rowIndex > -1) {
                                const storageIndex = selectedKeyList.indexOf((this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.hiddenSelectedKey]);
                                if(storageIndex > -1) {
                                    selectedKeyList.splice(storageIndex, 1);
                                }
                            }
                        }
                        (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey] = selectedKeyList.join(this.props.hiddenSelectedKeyDelimiter);
                    }
                } else {
                    (this.state as ReactMultiSelectSearchAsYouTypeState).storedData[this.props.dataKey] = "";
                }
            } else {
                // Use the first row currently displayed (using the startingIndex) to determine if we should mark all displayed rows as selected or unselected
                const markAsSelected = ((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length > 0) ? !(((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[startingIndex][this.props.isSelectedKey]) ? (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[startingIndex][this.props.isSelectedKey] : false) : false;

                // Mark all of the rows displayed as Selected/Unselected
                for (let i = startingIndex; i < endingIndex; i++) {
                    const rowIndex = this.indexOfRow((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[i]);
                    if (rowIndex >= 0) {
                        (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.isSelectedKey] = markAsSelected;
                    }
                }
            }

            // Update the current state
            this.setState({
                storedData: (this.state as ReactMultiSelectSearchAsYouTypeState).storedData,
                rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
                filteredRows: this.filterTable((this.state as ReactMultiSelectSearchAsYouTypeState).searchValue, (this.state as ReactMultiSelectSearchAsYouTypeState).rows, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData, 9),
                selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row, (this.state as ReactMultiSelectSearchAsYouTypeState).storedData);}),
                highlightSelectedRow: (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow,
                toolBarPageNumber: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber,
                toolBarPageNumberTyped: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumberTyped
            }, () => {this.updateHiddenSelectedKey();});

            if(null != this.props.selectHeaderClick) {
                this.props.selectHeaderClick((this.state as ReactMultiSelectSearchAsYouTypeState).storedData, true);
            }
        }
    }

    buildLabel() {
        return <label style={this.props.labelStyle} className={(null != this.props.labelCSS) ? this.props.labelCSS(this.indexOfSelected()) : ""}>
            {this.props.label}
        </label>
    }

    buildSearchButton() {
        return <button id={this.props.id + "_search"} className={"searchAsYouTypeButton ui-button ui-corner-all ui-widget ui-button-icon-only" + (((this.state as ReactMultiSelectSearchAsYouTypeState).disabled) ? " ui-button-disabled ui-state-disabled" : "")} tabIndex={this.props.searchButtonTabIndex} type="button" title="Search" onClick={this.onClick} disabled={(this.state as ReactMultiSelectSearchAsYouTypeState).disabled}>
            <span className="ui-button-icon ui-icon ui-icon-search"></span><span className="ui-button-icon-space"></span>
            Search
        </button>;
    }

    render() {
        // Render the MultiSelect SAYT (Note there are two internal tables, one for the selection and one for the searching)
        return <div id={this.props.id + '_shellDiv'} className={this.props.css} style={this.props.style}>
            {this.buildLabel()}
            <div id={this.props.id + '_subShellDiv'} style={{paddingBottom: '5px'}}>
                {<table className="categoryAllHide"><tr>
                    <td><input
                        id={this.props.disableID}
                        type="checkbox"
                        onChange={this.onDisableClick}
                        checked={(this.state as ReactMultiSelectSearchAsYouTypeState).disabled}
                    /></td>
                    <td>
                        HIDDEN DISABLE BUTTON
                    </td>
                </tr><tr>
                    <td><input
                        ref={this.hiddenSelectedKeyRef}
                        id={(null != this.props.hiddenSelectedKeyID) ? this.props.hiddenSelectedKeyID : this.props.id + "_hiddenSelectedKey"}
                        name={(null != this.props.hiddenSelectedKeyName) ? this.props.hiddenSelectedKeyName : this.props.id + "_hiddenSelectedKey"}
                        onClick={this.onHiddenKeyChange} // Could not get JQuery to update React onChange easily, but OnClick works!
                    /></td>
                    <td>
                        HIDDEN SELECTED KEY
                    </td>
                </tr>
                <tr>
                    <td><input id={this.props.id + "_highlight"} onClick={this.highlightRow} value={this.getIndexFromHighlight()} autoComplete="off" ></input></td>
                    <td>
                        HIDDEN HIGHLIGHT INDEX
                    </td>
                    <td><input id={this.props.hiddenTotalCountID} value={(this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length} autoComplete="off"/>
                    </td>
                    <td>
                        HIDDEN TOTAL COUNT
                    </td>
                    <td><button type="button" id={this.props.id + "_up"} onClick={event => {this.onKeyPress(new KeyboardEvent('keyup', { key: 'ArrowUp'}), true)}}>HIDDEN UP BUTTON</button></td>
                    <td><button type="button" id={this.props.id + "_down"} onClick={event => {this.onKeyPress(new KeyboardEvent('keydown', { key: 'ArrowDown'}),true)}}>HIDDEN DOWN BUTTON</button></td>
                    <td><button type="button" id={this.props.id + "_left"} onClick={event => {this.onKeyPress(new KeyboardEvent('keyleft', { key: 'ArrowLeft'}), true)}}>HIDDEN LEFT BUTTON</button></td>
                    <td><button type="button" id={this.props.id + "_right"} onClick={event => {this.onKeyPress(new KeyboardEvent('keyright', { key: 'ArrowRight'}), true)}}>HIDDEN RIGHT BUTTON</button></td>
                    <td><input
                        id={this.props.id + "_showTable"}
                        type="checkbox"
                        onChange={this.onShowWindowClick}
                        checked={(this.state as ReactMultiSelectSearchAsYouTypeState).showTable}
                    /></td>
                </tr>
                </table>
                }
                {getReactButton({id: this.props.refreshID, css: "categoryAllHide", onClick: this.onRefresh, text: "HIDDEN REFRESH BUTTON"})}
                {getReactButton({id: this.props.refreshSAYTTableID, css: "categoryAllHide", onClick: this.onRefreshSAYTOnly, text: "HIDDEN SAYT REFRESH BUTTON"})}
                {getReactButton({id: this.props.id + "_closePopupWindow", css: "categoryAllHide", onClick: this.onCloseWindowClick, text: "HIDDEN CLOSE POPUP BUTTON"})}
                <tr>
                    <td>
                        <table id={this.props.id + '_shellTable'}>
                            <tr>
                                <td>
                                    <input
                                        ref={this.inputRef}
                                        id={this.props.id}
                                        type="text"
                                        value={(this.state as ReactMultiSelectSearchAsYouTypeState).searchValue}
                                        tabIndex={this.props.tabIndex}
                                        style={this.props.textStyle}
                                        className={this.props.textCSS}
                                        onClick={this.onClick}
                                        onChange={this.handleChange}
                                        onKeyDown={this.onKeyPress}
                                        onKeyUp={this.onKeyUp}
                                        onFocus={this.onFocusIn}
                                        disabled={(this.state as ReactMultiSelectSearchAsYouTypeState).disabled}
                                        autoComplete={this.props.autoComplete}
                                        title={(null != this.props.title) ? this.props.title((this.state as ReactMultiSelectSearchAsYouTypeState).storedData) : ""}
                                    />
                                </td>
                                <td style={{verticalAlign: "middle", paddingLeft: "4px"}}>
                                    {(this.props.showSearchButton) ? this.buildSearchButton() : null}
                                </td>
                            </tr>
                            <tr id={this.props.id + '_saytTable_saytTableShell'}>
                                <td ref={this.popupRef} id={this.props.id + "_popUpWindowData"}>
                                {((this.state as ReactMultiSelectSearchAsYouTypeState).showTable) ? getReactTableLocal({
                                    id: this.props.id + '_saytTable',
                                    addSelectColumn: true,
                                    selectHeaderClick: this.selectAll,
                                    style: this.props.saytTableStyle,
                                    highlightSelectedRow: ((this.useHighlightSelectedRow) ? (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow : -1),
                                    toolBarPageNumber: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber,
                                    toolBarPageNumberTyped: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumberTyped,
                                    selectColumns: this.props.selectColumns,
                                    headers: this.props.selectionHeaders,
                                    headersCSS: this.props.selectionHeadersCSS,
                                    rowsCSS: this.props.selectionRowsCSS,
                                    rowsStyle: this.props.selectionRowsStyle,
                                    rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
                                    filteredRows: (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows,
                                    showTable: (this.state as ReactMultiSelectSearchAsYouTypeState).showTable,
                                    isSearchAsYouType: true,
                                    toolBarNumToDisplay: this.props.toolBarNumToDisplay,
                                    toolBarDisplayHeader: this.props.toolBarDisplayHeader,
                                    toolBarDisplayFooter: this.props.toolBarDisplayFooter,
                                    toolBarDisplayCompact: true,
                                    hideSAYTOnSelect: this.props.hideSearchOnSelect,
                                    onSelectCellClick: this.onSelectCellClick,
                                    toolBarUpdate: this.toolBarUpdate,
                                    sortUpdate: this.sortUpdate,
                                    onSortEvent: this.props.onSortEvent,
                                    disableHeaderScrolling: this.props.disableHeaderScrolling,
                                    noRecordsSelectedText: this.props.noRecordsSelectedText,
                                    addCustomFilterOptions: this.props.addCustomFilterOptions,
                                    customFilterCSS: this.props.customFilterCSS,
                                    css: this.props.divSAYTTableContainerCSS,
                                    toolBarRefreshID: this.props.toolBarRefreshID,
                                    onToolBarRefresh: this.props.onToolBarRefresh,
                                    selectRecordWithRowClick: this.props.selectRecordWithRowClick,
                                    selectRecordsWithRowDrag: this.props.selectRecordsWithRowDrag,
                                    isSelectedKey: this.props.isSelectedKey,
                                    hightlightSelectedRowCSS: this.props.hightlightSelectedRowCSS,
                                    rowHasFocusCSS: this.props.rowHasFocusCSS,
                                    onSAYTTableDisplayEvent: this.onSAYTTableDisplayEvent,
                                    divSAYTWindowCSS: this.props.divSAYTWindowCSS,
                                    storedData: (this.state as ReactMultiSelectSearchAsYouTypeState).storedData,
                                    useRowDataStorage: this.useRowDataStorage,
                                    hiddenSelectedKey: this.props.hiddenSelectedKey,
                                    hiddenSelectedKeyDelimiter: this.props.hiddenSelectedKeyDelimiter,
                                    dataKey: this.props.dataKey,
                                    storedDataAsJSONArray: this.storedDataAsJSONArray,
                                    newJSONData: this.props.newJSONData,
                                    overrideRowID: this.props.overrideRowID,
                                    overrideRowName: this.props.overrideRowName,
                                    selectCheckBoxID: this.props.selectCheckBoxID,
                                    selectCheckBoxName: this.props.selectCheckBoxName,
                                    overrideTableEntriesText: this.props.overrideTableEntriesText,
                                    overrideScrollIntoView: this.props.overrideScrollIntoView,
                                    searchValue: (this.state as ReactMultiSelectSearchAsYouTypeState).searchValue,
                                    overrideToolBarInfoText: this.props.overrideToolBarInfoText,
                                    updatePaging: this.updatePaging,
                                    toolBarDisablePaging: this.props.toolBarDisablePaging,
                                    toolBarDisplayTotal: this.props.toolBarDisplayTotal,
                                    onTableScroll: this.props.onTableScroll,
                                }) : null}
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </div>
            {getReactTableLocal({
                id: this.props.id + '_table',
                showTable: true,
                tableLabel: this.props.tableLabel,
                addSelectColumn: true,
                selectHeaderClick: this.unselectAll,
                style: this.props.tableStyle,
                disabled: (this.state as ReactMultiSelectSearchAsYouTypeState).disabled,
                headers: this.props.headers,
                headersCSS: this.props.headersCSS,
                rowsCSS: this.props.rowsCSS,
                rowsStyle: this.props.rowsStyle,
                rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
                filteredRows: (this.state as ReactMultiSelectSearchAsYouTypeState).selectedRows,
                highlightSelectedRow: -1,
                sortUpdate: this.selectedTableSortUpdate,
                selectColumns: this.props.selectColumns,
                onSelectCellClick: this.onSelectCellClick,
                disableHeaderScrolling: this.props.disableHeaderScrolling,
                noRecordsSelectedText: this.props.noRecordsSelectedText,
                css: this.props.divTableContainerCSS,
                selectRecordWithRowClick: this.props.selectRecordWithRowClick,
                selectRecordsWithRowDrag: this.props.selectRecordsWithRowDrag,
                isSelectedKey: this.props.isSelectedKey,
                hightlightSelectedRowCSS: this.props.hightlightSelectedRowCSS,
                rowHasFocusCSS: this.props.rowHasFocusCSS,
                onSortEvent: this.props.onSortEvent,
                storedData: (this.state as ReactMultiSelectSearchAsYouTypeState).storedData,
                useRowDataStorage: this.useRowDataStorage,
                hiddenSelectedKey: this.props.hiddenSelectedKey,
                hiddenSelectedKeyDelimiter: this.props.hiddenSelectedKeyDelimiter,
                dataKey: this.props.dataKey,
                storedDataAsJSONArray: this.storedDataAsJSONArray,
                newJSONData: this.props.newJSONData,
                overrideRowID: this.props.tableOverrideRowID,
                overrideRowName: this.props.tableOverrideRowName,
                selectCheckBoxID: this.props.tableSelectCheckBoxID,
                selectCheckBoxName: this.props.tableSelectCheckBoxName,
                overrideTableEntriesText: this.props.overrideTableEntriesText,
                overrideScrollIntoView: this.props.tableoverrideScrollIntoView,
                overrideToolBarInfoText: this.props.overrideToolBarInfoText,
                toolBarDisablePaging: this.props.toolBarDisablePaging,
            })}
        </div>;
    }
}
